export const FERMAAK_URL = 'https://fermaak.nl';

export function BrandLink() {
  return (
    <>
      A product by{' '}
      <a
        href={FERMAAK_URL}
        target="_blank"
        rel="noopener"
        className="font-semibold underline-offset-2 hover:underline"
      >
        FerMaak
      </a>{' '}
      • © 2026
    </>
  );
}
